import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Avatar,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Link,
  Typography,
} from '@material-ui/core';
import {
  ParkingType,
  ParkingStatus,
} from 'components'
import Moment from 'moment'
import getInitials from 'utils/getInitials';

const useStyles = makeStyles(theme => ({
  root: {},
  header: {
    paddingBottom: 0
  },
  content: {
    padding: 0,
    '&:last-child': {
      paddingBottom: 0
    }
  },
  description: {
    padding: theme.spacing(2, 3, 1, 3)
  },
  tags: {
    padding: theme.spacing(0, 3, 1, 3),
    '& > * + *': {
      marginLeft: theme.spacing(1)
    }
  },
  viewButton: {
    marginLeft: theme.spacing(2)
  },
  details: {
    padding: theme.spacing(1, 3)
  }
}));

const ParkingCard = props => {
  const { parking, className, ...rest } = props;

  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        avatar={
          <Avatar
            alt="Parking Logo"
            src={parking.logoSmall || parking.logo}
          >
            {getInitials(parking.name)}
          </Avatar>
        }
        className={classes.header}
        disableTypography
        title={
          <Link
            color="textPrimary"
            component={RouterLink}
            to={`/management/parkings/${parking.id}`}
            variant="h5"
          >
            {parking.name}
          </Link>
        }
      />
      <CardContent className={classes.content}>
        <div className={classes.description}>
          <Typography
            colo="textSecondary"
            variant="subtitle2"
          >
            {parking.description.length < 300 ? parking.description : `${parking.description.substring(0, 300)}...`}
          </Typography>
        </div>
        <div className={classes.tags}>
          <ParkingType type={parking.type}/>
          <ParkingStatus status={parking.status}/>
        </div>
        <Divider />
        <div className={classes.details}>
          <Grid
            alignItems="center"
            container
            justify="space-between"
            spacing={3}
          >
            <Grid item>
              <Typography variant="h5">{parking.city}</Typography>
              <Typography variant="body2">City</Typography>
              <Typography variant="body2">Created on: {parking.created ? Moment(parking.created).format('lll') : 'No Date'}</Typography>
            </Grid>
            <Grid item>
              <Button
                className={classes.viewButton}
                component={RouterLink}
                size="small"
                to={`/management/parkings/${parking.id}`}
              >
                View
              </Button>
            </Grid>
          </Grid>
        </div>
      </CardContent>
    </Card>
  );
};

ParkingCard.propTypes = {
  className: PropTypes.string,
  parking: PropTypes.object.isRequired
};

export default ParkingCard;
